/**
 * Global audience context for metrics tracking.
 * This module provides a way to share audience information with metrics adapters
 * without requiring direct access to the application store.
 */

let currentAudience: string = 'unknown'

/**
 * Gets the current audience type for metrics tracking.
 * @returns The current audience type as a string
 */
export function getMetricsAudience(): string {
  return currentAudience
}

/**
 * Sets the current audience type for metrics tracking.
 * This should be called whenever the audience changes in the application.
 * @param audience - The audience type to set
 */
export function setMetricsAudience(audience: string): void {
  currentAudience = audience
}

/**
 * Resets the audience to 'unknown'.
 * Useful for testing or initialization.
 */
export function resetMetricsAudience(): void {
  currentAudience = 'unknown'
}
